<template>
  <div id="sjList">
    <div id="tableView" v-loading="this.loading" element-loading-text="加载中">
      <el-row>
        <el-form label-width="75px" :inline="true" class="el-form demo-form-inline">
          <el-row>
            <el-col :span="8" class="searchInline">
              <label class="el-form-item__label searchLabel">企业名称</label>
              <el-input size="small" v-model="searchForm.qymc" placeholder="企业名称" clearable></el-input>
            </el-col>
            <el-col :span="8" class="searchInline">
              <label class="el-form-item__label searchLabel">批次</label>
              <el-select size="small" v-model="searchForm.reserve1" class="searchSelect" clearable placeholder="全部">
                  <el-option v-for="item in pcData" :key="item.uuid" :label="item.pc" :value="item.uuid"></el-option>
                </el-select>
            </el-col>
            <el-col :span="8" class="searchInline" v-if="!isfireexpoLeader">
              <label class="el-form-item__label searchLabel">是否设置</label>
              <el-select size="small" v-model="searchForm.issz" class="searchSelect" clearable placeholder="全部">
                <el-option key="1" label="是" value="1"></el-option>
                <el-option key="0" label="否" value="0"></el-option>
              </el-select>
            </el-col>
            
          </el-row>
          <div>
            <el-form>
              <el-col :span="12" class="btnEditDelete">
                <el-form-item align="left" v-if="!isfireexpoLeader">
                  <!-- <el-button type="primary" icon="edit" size="small" @click="editClick">修改</el-button> -->
                  <el-button type="success" icon="el-icon-plus" size="small" @click="addClick">批量设置</el-button>
                  <el-button type="danger" icon="el-icon-delete" size="small" @click="removeSelection">批量取消</el-button>
                  <!-- <el-button type="warning" icon="el-icon-setting" size="small" @click="setSelectionTime">设置展位选择时间
                  </el-button> -->
                </el-form-item>
              </el-col>
              <el-col :span="12"></el-col>
              <el-col :span="12" class="btnSearchPlus">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">查询</el-button>
                  <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearClick">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-form>
      </el-row>
      <div class="table_container">
        <el-table border id="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
          @selection-change="selectionChange" class="tableStyle" :height="tableheight" :row-style="rowStyle">
          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column type="index" show-overflow-tooltip label="序号" width="65" align="center"></el-table-column>
          <el-table-column prop="qymc" show-overflow-tooltip label="企业名称" min-width="35%" align="center">
          </el-table-column>
          <el-table-column prop="pcmc" show-overflow-tooltip label="批次名称" min-width="15%" align="center">
          </el-table-column>
          
          <el-table-column prop="starttime" show-overflow-tooltip label="开始时间" min-width="25%" align="center">
          </el-table-column>
          <el-table-column prop="endtime" show-overflow-tooltip label="结束时间" min-width="25%" align="center">
          </el-table-column>
          <el-table-column label="是否设置" width="60" align="center" v-if="!isfireexpoLeader">
            <template slot-scope="scope">
              <span v-if="scope.row.issz  != '是'" style="color:#F56C6C">{{scope.row.issz}}</span>
              <span v-else style="color:#67C23A">{{scope.row.issz}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center" v-if="!isfireexpoLeader">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row,scope.$index)">设置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页组件-->
        <el-row type="flex" justify="end">
          <paginator></paginator>
        </el-row>

        <!--展位选择时间安排弹框-->
        <el-dialog v-loading="this.dialogLoading" element-loading-text="加载中" :title="dialogTitle"
          :visible.sync="dialogFormVisible" @close="closeDialog()">
          <el-form :model="ruleForm1" :rules="rules" ref="ruleForm1" label-width="120px" class="tab">
            <el-row>
              <el-col :span="22">
                <el-form-item label="起始时间" :label-width="formLabelWidth" prop="starttime" class="tab1">
                  <el-date-picker type="datetime"  placeholder="请选择起始时间" value-format="yyyy-MM-dd HH:mm:ss"
                    size="small" v-model="ruleForm1.starttime" class="searchDatePicker">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="11">
                <el-form-item prop="timeBegin" label="起始时间" class="is-required">
                  <el-time-select placeholder="起始时间" prop="timeBegin" size="small" v-model="ruleForm1.timeBegin"
                    :picker-options="{ start: '00:00',   step: '00:30',   end: '23:30'}"></el-time-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="2">&nbsp;</el-col>
            </el-row>
            <el-row>
              <el-col :span='22'>
                <el-form-item label="终止时间" :label-width="formLabelWidth" prop="endtime" class="tab1">
                  <el-date-picker type="datetime" placeholder="请选择终止时间" value-format="yyyy-MM-dd HH:mm:ss"
                    size="small" v-model="ruleForm1.endtime" class="searchDatePicker">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="11">
                <el-form-item prop="timeEnd" label="终止时间" class="is-required">
                  <el-time-select placeholder="结束时间" prop="timeEnd" size="small" v-if="hackReset"
                    v-model="ruleForm1.timeEnd" :picker-options="{ start: '00:00',step: '00:30',end: '23:30' }">
                  </el-time-select>
                </el-form-item>
              </el-col> -->

              <el-col :span="2">&nbsp;</el-col>

            </el-row>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-row class="buttonSubmit">
              <el-button type="clear" icon="el-icon-close" size="small" class="btn_submit" @click="closeDialog()">取消
              </el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_save"
                @click="editSubmit('ruleForm1')">保存</el-button>
            </el-row>
          </div>
        </el-dialog>

      </div>

    </div>
  </div>
</template>
<script>
  //引入翻页 paginator
  import paginator from "@/components/paginator";

  export default {
    components: {
      paginator
    },
    data() {
      var validateSjn = (rule, value, callback) => {
        if (!value || value == "") {
          return callback(new Error('请选择日期'));
        } else {
          callback();
        }
      };
      var validateSj = (rule, value, callback) => {
        if (!value || value == "") {
          return callback(new Error('请选择时间'));
        } else {
          callback();
        }
      };
      return {
        formLabelWidth: '150px',
        //table高度
        tableheight: this.CONSTANT.tableheight10,
        //登陆用户
        currentUser: this.CONSTANT.currentUser,
        //显示加载中样
        loading: false,
        //当前页
        currentPage: 1,
        //分页大小
        pageSize: 10,
        //总记录数
        total: 0,
        //多选值
        multipleSelection: [],
        //搜索表单
        searchForm: {
          qymc: "",
          issz: "",
          qssj: "",
        },
        //弹窗标题
        dialogTitle: "",
        ruleForm1: {
          uuid: "",
          sjaplx: "",
          sjBegin: "",
          sjEnd: "",
          timeBegin: "",
          timeEnd: "",
          nr: "",
          sjaplxmc: "",
          qyid: "",

          starttime:"",
          endtime:""

        },
        dialogFormVisible: false,
        dialogDetailVisible: false,
        dialogLoading: false,
        //表数据
        tableData: [],
        //选中集合数据
        xzData: [],
        //表单验证规则
        rules: {
          timeBegin: [{
            validator: validateSj,
            trigger: "blur"
          }],
          timeEnd: [{
            validator: validateSj,
            trigger: "blur"
          }],
          sjBegin: [{
            required: true,
            message: "请选择起始时间",
            trigger: "change"
          }],
          sjEnd: [{
            required: true,
            message: "请选择终止时间",
            trigger: "change"
          }],

          starttime: [{
            required: true,
            message: "请选择起始时间",
            trigger: "change"
          }],
          endtime: [{
            required: true,
            message: "请选择终止时间",
            trigger: "change"
          }],
        },

        //批次数据
        pcData:[],
        isfireexpoLeader:false,
      };
    },
    created: function () {
      for(let i in this.currentUser.roles){
      if(this.currentUser.roles[i].rolename == 'fireexpoLeader'){
        this.searchForm.shzt = '03';
        this.isfireexpoLeader = true;
        break;
      }
    }

      this.hackReset = true;
      this.getPcData();
      this.searchClick("click");
      
    },
    methods: {
      getPcData: function(){
        let vm = this;
        vm.$axios.post("cfpayhsz/list", {}).then(res => {
          if (res.data.code == "00000000") {
            vm.pcData = res.data.result;
          }
        })
      },
      //表格查询事件
      searchClick: function (type) {
        let vm = this;
        //按钮事件的选择
        if (type == "page") {
          vm.tableData = [];
        } else {
          vm.currentPage = 1;
        }
        vm.loading = true; //表格重新加载
        var params = {
          qymc: vm.searchForm.qymc,
          reserve1: vm.searchForm.reserve1,
          issz: vm.searchForm.issz,
          pageSize: vm.pageSize,
          pageNum: vm.currentPage
        };
        vm.$axios.post("/zwtime/searchYhjgList", params).then(
          function (res) {
            var tableTemp = new Array((vm.currentPage - 1) * vm.pageSize);
            vm.tableData = tableTemp.concat(res.data.result.list);
            for (let i in vm.tableData) {
              if (vm.tableData[i].issz == "1") {
                vm.tableData[i].issz = "是"
              } else if (vm.tableData[i].issz == "0") {
                vm.tableData[i].issz = "否"
              }
            }
            vm.total = res.data.result.total;
            vm.loading = false;
          }.bind(vm),
          function (error) {
            vm.loading = false;
            console.log(error);
          }
        );
      },
      //清空查询条件
      clearClick: function () {
        (this.searchForm.qymc = ""),
        (this.searchForm.issz = ""),
        (this.searchForm.reserve1 = ""),
        this.searchClick("reset");
      },
      //表格勾选事件
      selectionChange: function (val) {
        this.multipleSelection = val;
      },
      //编辑事件
      editClick: function (val, index) {
        this.index = 1;
        let vm = this;
        this.dialogTitle = "展位选择时间特殊设置";
        var param = {
          qyid: val.qyid,
        };
        this.$axios.post("zwtime/doSearchTime", param).then(
          function (res) {
            if (res.data.code == "00000000") {
              //vm.ruleForm1.uuid = res.data.result.uuid;
              // if (res.data.result.starttime && res.data.result.starttime) {
              //   vm.ruleForm1.sjBegin = res.data.result.starttime.slice(0, 10);
              //   vm.ruleForm1.sjEnd = res.data.result.endtime.slice(0, 10);
              //   vm.ruleForm1.timeBegin = res.data.result.starttime.slice(10, 19);
              //   vm.ruleForm1.timeEnd = res.data.result.endtime.slice(10, 19);
              // }
              vm.ruleForm1.qyid = res.data.result.qyid;
              if (res.data.result.starttime && res.data.result.endtime) {
                vm.ruleForm1.starttime = res.data.result.starttime;
                vm.ruleForm1.endtime = res.data.result.endtime;
              }
            } else {
              vm.$message.error(res.data.msg);
              return false;
            }
          }.bind(this),
          function (error) {
            console.log(error);
          }
        );
        vm.dialogFormVisible = true;
      },
      //删除所选，批量取消
      removeSelection: function () {
        let vm = this;
        if (vm.multipleSelection.length < 1) {
          vm.$message({
            message: "请至少选中一条记录",
            type: "warning"
          });
          return;
        }
        vm.$confirm("确认取消选中信息设置?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            vm.loading = true;
            for (var i in vm.multipleSelection) {
              vm.multipleSelection[i].xgrid = vm.currentUser.userid;
              vm.multipleSelection[i].xgrmc = vm.currentUser.realname;
              vm.multipleSelection[i].czrmc = vm.currentUser.realname;
            }
            vm.$axios
              .post("/zwtime/cancelTimeByList2", vm.multipleSelection)
              .then(
                function (res) {
                  if (res.data.result > 0) {
                    vm.$message({
                      message: "成功取消" + res.data.result + "条展位选择时间设置信息",
                      showClose: true,
                      onClose: vm.searchClick("delete")
                    });
                    vm.loading = false;
                  } else {
                    vm.$message({
                      message: "取消失败",
                      type: "error"
                    });
                    vm.loading = false;
                  }
                }.bind(vm),
                function (error) {
                  vm.loading = false;
                  console.log(error);
                }
              );
          })
          .catch(() => {
            vm.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //批量新增事件
      addClick: function () {
        let vm = this;
        vm.xzData = [];
        if (vm.multipleSelection.length < 1) {
          vm.$message({
            message: "请至少选中一条记录",
            type: "warning"
          });
          return;
        }
        vm.xzData = vm.multipleSelection;
        this.dialogTitle = "展位选择时间批量特殊设置";
        this.index = 0;
        this.dialogFormVisible = true;
        if (this.$refs["ruleForm1"] !== undefined) {
          this.$refs["ruleForm1"].resetFields();
        }
      },

      // setSelectionTime: function () {
      //   let vm = this;
      //   vm.xzData = [{
      //     'uuid': -1
      //   }];
      //   this.editClick({
      //     'uuid': -1
      //   }, -1)
      //   this.dialogTitle = "设置展位选择时间";
      //   this.index = 2;
      //   this.dialogFormVisible = true;
      //   if (this.$refs["ruleForm1"] !== undefined) {
      //     this.$refs["ruleForm1"].resetFields();
      //   }
      // },
      
      //关闭Dialog
      closeDialog: function (val) {
        this.dialogFormVisible = false;
        this.$refs["ruleForm1"].resetFields();
        this.hackReset = false;
        this.$nextTick(() => {
          this.hackReset = true
        });

      },
      //保存或编辑
      editSubmit: function (val) {
        this.$refs["ruleForm1"].validate((valid) => {
          if (valid) {
            let vm = this;
            var val = this.ruleForm1;
            //时间处理
            vm.sjnBegin = val.sjBegin;
            vm.sjnEnd = val.sjEnd;
            if (vm.index == 0 && this.dialogTitle == "展位选择时间批量特殊设置") { //批量设置
              var qyidList = [];
              for (let i in vm.xzData) {
                qyidList.push(vm.xzData[i].qyid)
              }
              var params = {
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.realname,
                czrmc: vm.currentUser.realname,
                starttime: vm.ruleForm1.starttime,
                endtime: vm.ruleForm1.endtime,
                issz: "1",
                uuidlist: qyidList
              }
              this.$axios.post("zwtime/updateTimeByList2", params).then(
                function (res) {
                  if (res.data.code == "00000000") {
                    this.$message({
                      message: '保存成功！',
                      type: 'success',
                    });
                    this.dialogFormVisible = false;
                    this.searchClick();
                    vm.$refs["ruleForm1"].resetFields();
                  } else {
                    this.$message.error("保存失败！");
                    this.dialogFormVisible = false;
                  }
                  this.dialogLoading = false;
                }.bind(this),
                function (error) {
                  this.dialogLoading = false;
                  console.log(error);
                }
              );
            } else if (vm.index == 1 && this.dialogTitle == "展位选择时间特殊设置") { //修改
              var params = {
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.realname,
                czrmc: vm.currentUser.realname,
                
                starttime: vm.ruleForm1.starttime,
                endtime: vm.ruleForm1.endtime,
                issz: "1",
                //uuid: val.uuid,
                qyid: vm.ruleForm1.qyid
              }
                
              this.dialogLoading = true;
              this.$axios.post("zwtime/updateTimeByQyid", params).then(
                function (res) {
                  if (res.data.code == "00000000") {
                    this.$message({
                      message: '编辑成功！',
                      type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.searchClick();
                    vm.$refs["ruleForm1"].resetFields();
                  } else {
                    this.$message.error("编辑失败！");
                    this.dialogFormVisible = false;
                  }
                  this.dialogLoading = false;
                }.bind(this),
                function (error) {
                  this.dialogLoading = false;
                  console.log(error);
                }
              );
            } else if (vm.index == 2) { //设置展位选择时间
              var params = {
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.realname,

                czrmc: vm.currentUser.realname,
                starttime: vm.sjnBegin + " " + val.timeBegin,
                endtime: vm.sjnEnd + " " + val.timeEnd,
                issz: "1",
                uuid: vm.xzData[0].uuid
              }
              this.dialogLoading = true;
              this.$axios.post("zwtime/setBoothTimeByVO", params).then(
                function (res) {
                  if (res.data.code == "00000000") {
                    this.$message({
                      message: '编辑成功！',
                      type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.searchClick();
                    vm.$refs["ruleForm1"].resetFields();
                  } else {
                    this.$message.error("编辑失败！");
                    this.dialogFormVisible = false;
                  }
                  this.dialogLoading = false;
                }.bind(this),
                function (error) {
                  this.dialogLoading = false;
                  console.log(error);
                }
              );
            }
          } else {
            console.log('error save!!');
            return false;
          }
          // }

        });
      },
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/drawLots/drawLotsRecord.vue